import axios from 'axios'

// const url = 'https://x-cluster.com/b'
const url = 'https://cluster-dev.ru/b'

const instanceCluster = axios.create({ baseURL: url })

export default instanceCluster
